module.exports = __webpack_public_path__ + "files/1c1b1b25db595676268002267c0935e2.png";